import { useContext, useEffect, useState } from 'react';

import './CreateProductPopup.css';
import AdaptivePopup from '../../../../AdaptivePopup/AdaptivePopup';
import PlatformInput from '../../../PlatformInput/PlatformInput';
import publicApi from '../../../../../assets/api/PublicApi';
import { UserContext } from '../../../../../assets/contexts/userContext';
import { StringOrNothingFormater, getMinPrice, getRandomId, parsePrice } from '../../../../../assets/utils/utils';
import PreloaderBox from '../../../../PreloaderBox/PreloaderBox';
import Button from '../../../../Button/Button';
import { ERROR_PRICE_DATA_MIN_VALUE, ERROR_REQUIRED_FIELD } from '../../../../../assets/utils/constants';


const DEFAULT_FORM = {
    name: '',
    price: '',
    amount: 1,
}








function CreateProductPopup({ isOpen, handleClose, items, handleSelect }) {
    const { user } = useContext(UserContext)
    const [form, setForm] = useState(DEFAULT_FORM)
    const [formValidity, setFormValidity] = useState({
        price: {},
    })



    function handleChange(e) {
        const value = e.target.value
        const name = e.target.name
        switch (name) {
            case "price": {
                let inputValue = value.replace(/\D/g, "");
                setForm((prevValue) => ({
                    ...prevValue,
                    [name]: !inputValue ? "" : Number(inputValue).toString(),
                }));
                setFormValidity((prevValue) => ({
                    ...prevValue,
                    [name]: inputValue
                        ? Number(inputValue) > 0
                            ? {
                                errorMessage: "",
                                validState: true,
                            }
                            : {
                                errorMessage: ERROR_PRICE_DATA_MIN_VALUE,
                                validState: false,
                            }
                        : {
                            errorMessage: ERROR_REQUIRED_FIELD,
                            validState: false,
                        },
                }));
                break;
            }

            case "amount": {
                let inputValue = value.replace(/\D/g, "");
                setForm((prevValue) => ({
                    ...prevValue,
                    [name]: !inputValue ? "" : Number(inputValue).toString(),
                }));
                // setProductValidity((prevValue) => ({
                //   ...prevValue,
                //   [name]: inputValue ?
                //     {
                //       errorMessage: "",
                //       validState: true,
                //     }
                //     :
                //     {
                //       errorMessage: ERROR_REQUIRED_FIELD,
                //       validState: false,
                //     },
                // }));
                break;
            }
            default: {
                setForm(prevValue => ({
                    ...prevValue,
                    [name]: value,
                }))
                break;
            }
        }
    }
    function onClosePopup() {
        handleClose()
        setTimeout(() => {
            setForm(DEFAULT_FORM)
        }, 300);
    }

    function handleSelectItem(item) {
        onClosePopup()
        handleSelect({ ...item, type: 'custom', _id: getRandomId() })
    }
    return (
        <AdaptivePopup
            isOpen={isOpen}
            handleClose={onClosePopup}
            popupName={'createProduct'}
        >
            <div className='create-product-popup'>
                <p className='create-product-popup__title'>Cвободный товар</p>
                <PlatformInput
                    value={form.name}
                    handleChange={handleChange}
                    label={'Название'}
                    type={'text'}
                    inputMode='text'
                    name={'name'}
                    show_eror_color_only

                />
                <PlatformInput
                    value={form.price}
                    handleChange={handleChange}
                    label={'Цена'}
                    type={'text'}
                    inputMode='numeric'
                    name={'price'}
                    show_eror_color_only

                />
                {/* <PlatformInput
                    value={form.amount}
                    handleChange={handleChange}
                    label={'Название'}
                    type={'text'}
                    inputMode='numeric'
                    name={'amount'}
                    show_eror_color_only

                /> */}
                <Button
                    text={'Добавить'}
                    isInvalid={!(formValidity.price.validState && form.price && form.name)}
                    isContrastColor
                    className={'create-product-popup__btn '}
                    onClick={() => {
                        handleSelectItem(form)
                    }}
                />
            </div>
        </AdaptivePopup>
    );
}

export default CreateProductPopup